import Loadable from 'react-loadable'
import globalRoutes from './global'
import hunaRoutes from './huna'
console.log(123)

export const routes = [
    // 首页
    {
        path: '/',
        exact: true,
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: "page-Home" */ '../pages/home_huna_lite'),
            loading: () => null,
        }),
    },
]

const allRoutes = routes
  .concat(globalRoutes, hunaRoutes)
  .concat({
    path: '',
    exact: false,
    component: Loadable({
      loader: () =>
        import(/* webpackChunkName: "page-NotFound" */ '../pages/404'),
      loading: () => null,
    }),
  })

export default store => allRoutes
